import Button, { Theme } from "theme/components/buttons/Button";

import React from "react";
import colors from "theme/config/colors";

const WhiteSolidButton = (props: any) => {
    const theme: Theme = {
        color: colors.black,
        backgroundColor: colors.white,
        borderColor: colors.white,
        hover: {
            backgroundColor: colors.neutral_50,
            borderColor: colors.neutral_50,
        },
        active: {
            backgroundColor: colors.neutral_100,
            borderColor: colors.neutral_100,
        },
        selected: {
            color: colors.white,
            backgroundColor: colors.blue_700,
            borderColor: colors.blue_700,
        },
        disabled: {
            color: colors.blue_700, //or Neutral/400 without opacity?
            opacity: "30%",
        },
    };

    return <Button {...props} theme={theme} />;
};

export default WhiteSolidButton;
